import { type PropsWithChildren, useMemo } from 'react';

import { useGetAuthCSRF, useGetAuthInfo } from '../../api';
import { AuthContext } from '../../model';

export const AuthProvider = ({ children }: PropsWithChildren) => {
  useGetAuthCSRF();
  const { data } = useGetAuthInfo();

  const provider = useMemo(
    () => ({ isAuthenticated: !!data, userAuthInfo: data }),
    [data],
  );

  return (
    <AuthContext.Provider value={provider}>{children}</AuthContext.Provider>
  );
};
